import { Loading } from 'element-ui'
const $loading = Loading.service

const state = () => ({
  loading: null
})

const getters = {
  isLoading: state => !!state.loading
}

const mutations = {
  setLoading (state, value) {
    if (value === true) {
      if (!state.loading) {
        state.loading = $loading({
          text: 'Cargando'
        })
      }
    } else {
      if (state.loading) {
        state.loading.close()
      }
      state.loading = null
    }
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
